import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';

@Component({
    selector: 'app-mobile-photo-modal',
    templateUrl: './mobile-photo-modal.component.html',
    styleUrls: [],
    animations: modalAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class MobilePhotoModalComponent {
    @Input() modalTitle: string;
    @Input() content: string;
    @Input() telephone: string;
    @Input() icon: string;
    @Input() iconInfo: string;
    @Input() postAppointmentModalContent: string;
    @Input() closeButton: string;
    @Input() buttonRight = 'global.button.confirm';
    @Input() buttonLeft = 'global.button.cancel';
    @Input() visibility: boolean;

    @Output() visibilityChange = new EventEmitter<boolean>();
    @Output() buttonClicked = new EventEmitter<boolean>();
    @Output() rightClick = new EventEmitter<boolean>();
    @Output() leftClick = new EventEmitter<boolean>();
    @Output() crossClick = new EventEmitter<boolean>();

    close() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
        this.buttonClicked.emit(true);
    }
    buttonCrossClick() {
        this.crossClick.emit(true);
    }
    buttonRightClick() {
        this.rightClick.emit(true);
    }
    buttonLeftClick() {
        this.leftClick.emit(true);
    }
}
